export const VipTrialEvent = {
  VipTrialBannerClick: 'vip_trial_banner_click',
  ReferralBenefitsClick: 'referral_benefits_click',
  VipTrialShareLinkClick: 'vip_trial_share_link_click',
  VipTrialLandingPageClick: 'vip_trial_landing_page_click',
} as const;

export interface VipTrialEventDataType {
  [VipTrialEvent.VipTrialBannerClick]: {
    image_name: string;
    event_type: string;
  };
  [VipTrialEvent.ReferralBenefitsClick]: {
    activated_vip_invites: number;
  };
  [VipTrialEvent.VipTrialShareLinkClick]: {
    activated_vip_invites: number;
  };
  [VipTrialEvent.VipTrialLandingPageClick]: {
    banner_text: string;
  };
}

export const VipStatusEvent = {
  VipStatusPageVipBenefitClick: 'vip_status_page_vip_benefit_click',
  VipStatusPageShareVipClick: 'vip_status_page_share_vip_click',
};

export const VipEvent = {
  VipPageView: 'vip_page_view',
} as const;

export interface VipEventDataType {
  [VipEvent.VipPageView]: {};
}

export const VipRequirementEvent = {
  VipRequirementPageView: 'vip_requirement_page_view',
  VipRequirementActionClick: 'vip_requirement_action_click',
  VipRequirementPerkDetailClick: 'vip_requirement_perk_detail_click',
} as const;

export interface VipRequirementEventDataType {
  [VipRequirementEvent.VipRequirementPageView]: {
    vip_status?: string;
  };
  [VipRequirementEvent.VipRequirementActionClick]: {
    action_type: 'trade' | 'deposit';
    usdt_balance: number;
    '15_days_volume': number;
  };
  [VipRequirementEvent.VipRequirementPerkDetailClick]: {
    tab_name: string;
  };
}
